/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{cursor:pointer;display:-webkit-box;display:flex;-webkit-column-gap:8px;column-gap:8px}.teacher-switch-fallback-item--checked[_nghost-%COMP%]   .label[_ngcontent-%COMP%]{font-family:PoppinsSemiBold}.label[_ngcontent-%COMP%]{font-size:14px;margin-bottom:0;line-height:18px}.description[_ngcontent-%COMP%]{font-size:12px;line-height:10px;color:#999;margin-bottom:0}"];
export { styles as styles };
//# sourceMappingURL=teacher-switch-fallback-item.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/shared/teacher-switch/teacher-switch-modal/teacher-switch-fallback-item/teacher-switch-fallback-item.component.scss.shim.ngstyle.js
// module id = 1273
// module chunks = 26 27 28